export default __webpack_public_path__ + "static/media/avatar_brown_bear9.90867697.mp3";